export default "__VITE_ASSET__59fe7cfd__"